const formControlLabelFormControlAbel = {
  label: 'ON DEMAND (NO DEFINED TIME)'
};

export default formControlLabelFormControlAbel;
